import script from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=f15f29de&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f15f29de"]])

export default __exports__